export const FETCH_SHOPS_REQUEST = 'FETCH_SHOPS_REQUEST';
export const FETCH_SHOPS_SUCCESS = 'FETCH_SHOPS_SUCCESS';
export const FETCH_ADMIN_SHOPS_BY_ID = 'FETCH_ADMIN_SHOPS_BY_ID';
export const SAVE_SHOP_REQUEST = 'SAVE_SHOP_REQUEST';
export const SAVE_SHOP_SUCCESS = 'SAVE_SHOP_SUCCESS';
export const FETCH_SHOP_SUBSCRIPTION = 'FETCH_SHOP_SUBSCRIPTION';
export const UPDATE_SHOP_SUBSCRIPTION = 'UPDATE_SHOP_SUBSCRIPTION';
export const PLAN_TYPES = [
  'PRO',
  'EXECUTIVE',
  'TITAN',
  'INDEPENDENT',
  'INDEPENDENT_EXECUTIVE',
];
export const FETCH_SUBSCRIPTION_CHARGE = 'FETCH_SUBSCRIPTION_CHARGE';
export const CREATE_SUBSCRIPTION_CHARGE = 'CREATE_SUBSCRIPTION_CHARGE';
export const UPDATE_SUBSCRIPTION_CHARGE = 'UPDATE_SUBSCRIPTION_CHARGE';
export const FETCH_SHOP_LOAN = 'FETCH_SHOP_LOAN';
export const CREATE_SHOP_LOAN = 'CREATE_SHOP_LOAN';
export const UPDATE_SHOP_LOAN = 'UPDATE_SHOP_LOAN';
export const FETCH_COUPONS = 'FETCH_COUPONS';
export const FETCH_HOURLY_WAGE_RULES = 'FETCH_HOURLY_WAGE_RULES';
export const FETCH_SHOP_SUCCESS = 'FETCH_SHOP_SUCCESS';
export const FETCH_SHOPS_DISABLED_SUCCESS = 'FETCH_SHOPS_DISABLED_SUCCESS';
